import { useState, useEffect } from "react";
import "./style.css";
import { useLocation } from "react-router-dom";
const API_URL = process.env.REACT_APP_API_URL;
const DummyData = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const mac = params.get("id");

  const [ph, setph] = useState(0);
  const [Do, setDo] = useState(0);
  const [temp, settemp] = useState(0);
  const [orp, setorp] = useState(0);
  const [phlow, setphlow] = useState(0);

  const [voltage, setvoltage] = useState(0);
  const [current, setcurrent] = useState(0);
  const [phhigh, setphhigh] = useState(0);
  const [name, setname] = useState("");
  const [orplow, setorplow] = useState(0);
  const [orphigh, setorphigh] = useState(0);
  const [dolow, setdolow] = useState(0);
  const [dohigh, setdohigh] = useState(0);
  const [templow, settemplow] = useState(0);
  const [temphigh, settemphigh] = useState(0);
  const [vollow, setvollow] = useState(0);
  const [volhigh, setvolhigh] = useState(0);
  const [currlow, setcurrlow] = useState(0);
  const [currentHigh, setcurrentHigh] = useState(0);
  const [c_phlow, setc_phlow] = useState(0);
  const [c_phhigh, setc_phhigh] = useState(0);
  const [c_orplow, setc_orplow] = useState(0);
  const [c_orphigh, setc_orphigh] = useState(0);
  const [c_dolow, setc_dolow] = useState(0);
  const [c_dohigh, setc_dohigh] = useState(0);
  const [c_templow, setc_templow] = useState(0);
  const [c_temphigh, setc_temphigh] = useState(0);
  const [c_vollow, setc_vollow] = useState(0);
  const [c_volhigh, setc_volhigh] = useState(0);
  const [c_currlow, setc_currlow] = useState(0);
  const [c_currentHigh, setc_currentHigh] = useState(0);
  const [o_time_on, seto_time_on] = useState(0);
  const [o_delay_after_on, seto_delay_after_on] = useState(0);
  const [o_ph_active_time, seto_ph_active_time] = useState(0);
  const [o_start_active_on, seto_start_active_on] = useState(0);
  const [o_dosing_gpio, seto_dosing_gpio] = useState(0);
  const [o_chlorine_pump_time, seto_chlorine_pump_time] = useState(0);
  const [o_alum_gpio, seto_alum_gpio] = useState(0);
  const [rs485, setrs485] = useState("");
  const [dosing, setdosing] = useState("");
  const [rs4852, setrs4852] = useState("");
  const [dosing2, setdosing2] = useState("");
  const [sandfilter, setsandfilter] = useState("");
  const [time_on, settime_on] = useState(0);
  const [delay_after_on, setdelay_after_on] = useState(0);
  const [ph_active_time, setph_active_time] = useState(0);
  const [start_active_on, setstart_active_on] = useState(0);
  const [dosing_gpio, setdosing_gpio] = useState(0);
  const [chlorine_pump_time, setchlorine_pump_time] = useState(0);
  const [alum_gpio, setalum_gpio] = useState(0);
  const [move_2, setmove_2] = useState("");
  const [move_station, setmove_station] = useState("");
  const [move_pwm, setmove_pwm] = useState("");
  const [stop, setstop] = useState("");
  const [read, setread] = useState("");
  const [info, setinfo] = useState("");
  const [status, setstatus] = useState("");
  const [ble_name, setble_name] = useState("");
  const [rs485command, setrs485command] = useState("");
  const [selectedCardIndex, setSelectedCardIndex] = useState(0);
  const isMobile = window.innerWidth <= 600;
  const setterMap = {
    temp: settemp,
    ph: setph,
    Do: setDo,
    voltage: setvoltage,
    current: setcurrent,
    orp: setorp,
    time_on: settime_on,
    ph_active_time: setph_active_time,
    start_active_on: setstart_active_on,
    dosing_gpio: setdosing_gpio,
    chlorine_pump_time: setchlorine_pump_time,
    delay_after_on: setdelay_after_on,
    alum_gpio: setalum_gpio,
    o_time_on: seto_time_on,
    o_ph_active_time: seto_ph_active_time,
    o_start_active_on: seto_start_active_on,
    o_dosing_gpio: seto_dosing_gpio,
    o_chlorine_pump_time: seto_chlorine_pump_time,
    o_delay_after_on: seto_delay_after_on,
    o_alum_gpio: seto_alum_gpio,
    move_pwm: setmove_pwm,
    move_station: setmove_station,
    stop: setstop,
    read: setread,
    status: setstatus,
    rs485command: setrs485command,
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    const setter = setterMap[name];
    if (setter) setter(value);
  };

  const handleInputChange2 = (e) => {
    const { name, checked } = e.target;

    const setter = setterMap[name];
    if (setter) setter(checked);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response3 = await fetch(
          `${API_URL}/getthreshold.php?getdata=${mac}`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
          }
        );

        const text = await response3.text();
        const json3 = text ? JSON.parse(text) : {};
        setDo(json3?.DO);
        setph(json3?.PH);
        settemp(json3?.Temperature);
        setorp(json3?.ORP);
        setvoltage(json3?.Voltage);
        setcurrent(json3?.Current);
        setphlow(parseFloat(json3?.pHLow) || 0.0);
        setphhigh(parseFloat(json3?.pHHigh) || 0.0);
        setorplow(parseFloat(json3?.ORPLow) || 0.0);
        setorphigh(parseFloat(json3?.ORPHigh) || 0.0);
        setdolow(parseFloat(json3?.DOLow) || 0.0);
        setdohigh(parseFloat(json3?.DOHigh) || 0.0);
        settemplow(parseFloat(json3?.temperatureLow) || 0.0);
        settemphigh(parseFloat(json3?.temperatureHigh) || 0.0);
        setvollow(parseFloat(json3?.voltageLow) || 0.0);
        setvolhigh(parseFloat(json3?.voltageHigh) || 0.0);
        setcurrlow(parseFloat(json3?.currentLow) || 0.0);
        setcurrentHigh(parseFloat(json3?.currentHigh) || 0.0);
        setc_phlow(parseFloat(json3?.c_pHLow) || 0.0);
        setc_phhigh(parseFloat(json3?.c_pHHigh) || 0.0);
        setc_orplow(parseFloat(json3?.c_ORPLow) || 0.0);
        setc_orphigh(parseFloat(json3?.c_ORPHigh) || 0.0);
        setc_dolow(parseFloat(json3?.c_DOLow) || 0.0);
        setc_dohigh(parseFloat(json3?.c_DOHigh) || 0.0);
        setc_templow(parseFloat(json3?.c_temperatureLow) || 0.0);
        setc_temphigh(parseFloat(json3?.c_temperatureHigh) || 0.0);
        setc_vollow(parseFloat(json3?.c_voltageLow) || 0.0);
        setc_volhigh(parseFloat(json3?.c_voltageHigh) || 0.0);
        setc_currlow(parseFloat(json3?.c_currentLow) || 0.0);
        setc_currentHigh(parseFloat(json3?.c_currentHigh) || 0.0);
        setname(json3?.name);
        setrs485(json3?.rs485);
        setdosing(json3?.dosing);
        setrs4852(json3?.rs4852);
        setdosing2(json3?.dosing2);
        setsandfilter(json3?.sand_filter);
        settime_on(parseInt(json3?.time_on));
        setdelay_after_on(parseInt(json3?.delay_after_on));
        setph_active_time(parseInt(json3?.ph_active_time));
        setstart_active_on(parseFloat(json3?.start_active_on));
        setdosing_gpio(parseFloat(json3?.dosign_acid_current_gpio));
        setchlorine_pump_time(parseFloat(json3?.chlorine_pump_time));
        setalum_gpio(parseFloat(json3?.alum_current_gpio));
        seto_time_on(parseInt(json3?.o_time_on));
        seto_delay_after_on(parseInt(json3?.o_delay_after_on));
        seto_ph_active_time(parseInt(json3?.o_ph_active_time));
        seto_start_active_on(parseFloat(json3?.o_start_active_on));
        seto_dosing_gpio(parseFloat(json3?.o_dosign_acid_current_gpio));
        seto_chlorine_pump_time(parseFloat(json3?.o_chlorine_pump_time));
        seto_alum_gpio(parseFloat(json3?.o_alum_current_gpio));
        setmove_station(json3?.run_station?.split(",")[0]);
        setmove_pwm(json3?.run_station?.split(",")[1]);
        setmove_2(json3?.run_station?.split(",")[2]);
        setstop(json3?.stop === "true");
        setread(json3?.read_command === "true");
        setstatus(json3?.status === "true");
        setrs485command(json3?.rs485_command === "true");
        setinfo(json3?.info);
        setble_name(json3?.ble_name);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [mac]);

  const fetchSettings = async () => {
    try {
      await fetch(`${API_URL}/getthreshold.php`, {
        method: "GET",
        headers: { Accept: "application/json" },
      });
    } catch (err) {
      console.error("Error fetching settings:", err);
    }
  };

  const handleSave = async () => {
    try {
     await fetch(`${API_URL}/index.php`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          PH: ph || "",
          PH_electrode: "",
          ORP: orp || "",
          ORP_electrode: "",
          Temperature: temp || "",
          timestamp: new Date(),
          mac: mac,
          name: name,
        }),
      });
      await fetch(`${API_URL}/unit.php`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          DO: Do || "",
          DO_elect: "",
          Do_con: "",
          Temp: "",
          Voltage: voltage || "",
          timestamp: new Date(),
          mac: mac,
          Current: current,
        }),
      });
    
     await fetch(
        `${API_URL}/getthreshold.php`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            pHHigh: phhigh || "",
            pHLow: phlow || "",
            ORPHigh: orphigh || "",
            ORPLow: orplow || "",
            DOHigh: dohigh || "",
            DOLow: dolow || "",
            temperatureHigh: temphigh || "",
            temperatureLow: templow || "",
            voltageHigh: volhigh || "",
            voltageLow: vollow || "",
            currentHigh: currentHigh || "",
            currentLow: currlow || "",
            c_pHHigh: c_phhigh || "",
            c_pHLow: c_phlow || "",
            c_ORPHigh: c_orphigh || "",
            c_ORPLow: c_orplow || "",
            c_DOHigh: c_dohigh || "",
            c_DOLow: c_dolow || "",
            c_temperatureHigh: c_temphigh || "",
            c_temperatureLow: c_templow || "",
            c_voltageHigh: c_volhigh || "",
            c_voltageLow: c_vollow || "",
            c_currentHigh: c_currentHigh || "",
            c_currentLow: c_currlow || "",
            mac: mac || "",
            name: name || "",
            time_on: time_on || "",
            delay_after_on: delay_after_on || "",
            ph_active_time: ph_active_time || "",
            start_active_on: start_active_on || "",
            dosign_acid_current_gpio: dosing_gpio || "",
            chlorine_pump_time: chlorine_pump_time || "",
            alum_current_gpio: alum_gpio || "",
            run_station: move_station + "," + move_pwm + "," + move_2 || "",
            o_time_on: o_time_on || "",
            o_delay_after_on: o_delay_after_on || "",
            o_ph_active_time: o_ph_active_time || "",
            o_start_active_on: o_start_active_on || "",
            o_dosign_acid_current_gpio: o_dosing_gpio || "",
            o_chlorine_pump_time: o_chlorine_pump_time || "",
            o_alum_current_gpio: o_alum_gpio || "",
            info: info?.toString() || "",
            ble_name: ble_name || "",
            stop: stop?.toString(),
            read_command: read?.toString(),
            status: status?.toString(),
            rs485_command: rs485command?.toString(),
          }),
        }
      );
      alert("Settings Updated");
      await fetchSettings();
    } catch (err) {
      console.log("Error saving settings:", err);
    }
  };

  return (
    <div className="container">
      <div className="topnav">
        {[rs485, rs4852, dosing, dosing2, sandfilter].map(
          (enabled, idx) =>
            enabled && (
              <button
                key={idx}
                onClick={() => setSelectedCardIndex(idx)}
                className={selectedCardIndex === idx ? "active" : "inactive"}
              >
                {
                  [
                    "PH/ORP/Temp",
                    "Chlorine/PH/Temp",
                    "Acid",
                    "Others",
                    "Sand Filter",
                  ][idx]
                }
              </button>
            )
        )}
      </div>
      <div className="content">
        {selectedCardIndex === 0 && (
          <div className="form-section">
            <h2 className="heading">
              {selectedCardIndex === 0
                ? "PH/ORP/Temp Settings"
                : "Chlorine/PH/Temp Settings"}
            </h2>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleSave();
              }}
            >
              {[
                { label: "Temperature", name: "temp", value: temp },
                { label: "PH", name: "ph", value: ph },
                { label: "Conductivity", name: "Do", value: Do },
                { label: "Voltage", name: "voltage", value: voltage },
                { label: "Current", name: "current", value: current },
                { label: "ORP", name: "orp", value: orp },
              ].map((field) => (
                <div className="form-group" key={field.label}>
                  <label>{field?.label.toUpperCase()}</label>
                  <input
                    type="number"
                    name={field.name}
                    value={field.value}
                    onChange={handleInputChange}
                    step="any"
                    required
                  />
                </div>
              ))}
              <button type="submit" className="save-button">
                Save Settings
              </button>
            </form>
          </div>
        )}
        {selectedCardIndex === 1 && (
          <div className="form-section">
            <h2 className="heading">
              {selectedCardIndex === 0
                ? "PH/ORP/Temp Settings"
                : "Chlorine/PH/Temp Settings"}
            </h2>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleSave();
              }}
            >
              {[
                { label: "Temperature", name: "temp", value: temp },
                { label: "PH", name: "ph", value: ph },
                { label: "Chlorine", name: "Do", value: Do },
                // {label:"Voltage",name:"voltage",value:voltage},
                // {label:"Current",name:"current",value:current},
                { label: "ORP", name: "orp", value: orp },
              ].map((field) => (
                <div className="form-group" key={field.label}>
                  <label>{field?.label.toUpperCase()}</label>
                  <input
                    type="number"
                    name={field.name}
                    value={field.value}
                    onChange={handleInputChange}
                    step="any"
                    required
                  />
                </div>
              ))}
              <button type="submit" className="save-button">
                Save Settings
              </button>
            </form>
          </div>
        )}

        {selectedCardIndex === 2 && (
          <div
            className="form-section"
            style={{ marginTop: isMobile ? "250px" : "5px" }}
          >
            <h2 className="heading">Acid Settings</h2>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleSave();
              }}
            >
              {[
                { label: "timeOnDelay", name: "time_on", value: time_on },
                {
                  label: "phActiveTime",
                  name: "ph_active_time",
                  value: ph_active_time,
                },
                {
                  label: "startActiveOn",
                  name: "start_active_on",
                  value: start_active_on,
                },
                {
                  label: "dosingGpio3",
                  name: "dosing_gpio",
                  value: dosing_gpio,
                },
                {
                  label: "chlorinePump",
                  name: "chlorine_pump_time",
                  value: chlorine_pump_time,
                },
                { label: "alumGpio3", name: "alum_gpio", value: alum_gpio },
                {
                  label: "delayafteron",
                  name: "delay_after_on",
                  value: delay_after_on,
                },
              ].map((name) => (
                <div className="form-group" key={name}>
                  <label>{name.label}</label>
                  <input
                    type="number"
                    name={name.name}
                    value={name.value}
                    onChange={handleInputChange}
                    step="any"
                  />
                </div>
              ))}
              <button type="submit" className="save-button">
                Save Settings
              </button>
            </form>
          </div>
        )}

        {selectedCardIndex === 3 && (
          <div
            className="form-section"
            style={{ marginTop: isMobile ? "330px" : "5px" }}
          >
            <h2 className="heading">Others Settings</h2>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleSave();
              }}
            >
              {[
                { label: "timeOnDelay", name: "o_time_on", value: o_time_on },
                {
                  label: "phActiveTime",
                  name: "o_ph_active_time",
                  value: o_ph_active_time,
                },
                {
                  label: "startActiveOn",
                  name: "o_start_active_on",
                  value: o_start_active_on,
                },
                {
                  label: "dosingGpio3",
                  name: "o_dosing_gpio",
                  value: o_dosing_gpio,
                },
                {
                  label: "chlorinePump",
                  name: "o_chlorine_pump_time",
                  value: o_chlorine_pump_time,
                },
                { label: "alumGpio3", name: "o_alum_gpio", value: o_alum_gpio },
                {
                  label: "delayafteron",
                  name: "o_delay_after_on",
                  value: o_delay_after_on,
                },
              ].map((name) => (
                <div className="form-group" key={name}>
                  <label>{name.label}</label>
                  <input
                    type="number"
                    name={name.name}
                    value={name.value}
                    onChange={handleInputChange}
                    step="any"
                  />
                </div>
              ))}
              <button type="submit" className="save-button">
                Save Settings
              </button>
            </form>
          </div>
        )}

        {selectedCardIndex === 4 && (
          <div
            className="form-section"
            style={{ marginTop: isMobile ? "200px" : "5px" }}
          >
            <h2 className="heading">Sand Filter Settings</h2>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleSave();
              }}
            >
              {[
                {
                  label: "PWM",
                  name: "move_pwm",
                  type: "input",
                  value: move_pwm,
                },
                {
                  label: "Station",
                  name: "move_station",
                  type: "input",
                  value: move_station,
                },
                { label: "Stop", name: "stop", type: "switch", value: stop },
                { label: "Read", name: "read", type: "switch", value: read },
                {
                  label: "Status",
                  name: "status",
                  type: "switch",
                  value: status,
                },
                {
                  label: "RS485",
                  name: "rs485command",
                  type: "switch",
                  value: rs485command,
                },
              ].map(({ label, name, type, value }) => (
                <div className="form-group" key={name}>
                  <label>{label}</label>
                  {type === "input" ? (
                    <input
                      type="number"
                      name={name}
                      className="sandFilter"
                      value={value}
                      onChange={handleInputChange}
                      required
                    />
                  ) : (
                    <label className="switch">
                      <input
                        type="checkbox"
                        name={name}
                        checked={value === true}
                        onChange={(e) => {
                          handleInputChange2(e);
                        }}
                      />
                      <span className="slider round"></span>
                    </label>
                  )}
                </div>
              ))}
              <button type="submit" className="save-button">
                Save Settings
              </button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default DummyData;
